import { render, staticRenderFns } from "./pages-grid.vue?vue&type=template&id=53aa56de"
import script from "./pages-grid.vue?vue&type=script&lang=js"
export * from "./pages-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports